import type { SourceScheduleInput } from "../../../shared/types";

/**
 * The one starting calendar every source-schedule form proposes: daily at 09:00 in the
 * viewer's timezone. Setup, edit, and history-import forms share it so a source is never
 * offered two different "defaults" depending on which page it was set up from.
 */
export function defaultSourceSchedule(timezone = Intl.DateTimeFormat().resolvedOptions().timeZone): SourceScheduleInput {
  return { frequency: "daily", time: "09:00", timezone };
}
